// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SingleCard_wrapper__3_cM2"};